// extracted by mini-css-extract-plugin
export default {"detail_container":"CustomerCreate_detail_container__vl2cz","title":"CustomerCreate_title__ZsT4c","button":"CustomerCreate_button__AimjQ"};